import React, { Component } from "react";
import { Grid, Row, Col, Image } from "react-bootstrap";
import Slider from "react-slick";
import './Partners.css';

export default class Partners extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }
  render() {
    const settings = {
      className: "center",
      centerMode: true,
      infinite: true,
      centerPadding: "60px",
      slidesToShow: 3,
      autoplay: true,
      speed: 500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div className="Partners">
        <Grid>
          <Row className="title-partners-logos">
            <Col md={12}>
              <h3 className="title"><b>Han confiado en nosotros</b></h3>
            </Col>
          </Row>
        </Grid>
        <Grid className="partners-logos">
          <Row>
            <Col md={12}>
              <Slider {...settings}>       
                <div><Image src="/images/partners/falabella-inm.jpg" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/cencosud.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/Walmart_Chile.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/sodimac-homecenter.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/tottus.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/mallplaza.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/entel.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/campos.png" alt="" title="" responsive /></div> 
                <div><Image src="/images/partners/avanzapark.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/mop.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/urbanoproyectos.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/serviu2.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/muni-santiago.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/salfa.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/tecsa.jpg" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/cchc.png" alt="" title="" responsive /></div>
                <div><Image src="/images/partners/ebco.jpg" alt="" title="" responsive /></div>
              </Slider>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                Más que obras <span className="bold">construimos espacios</span> que identifican <span className="bold">a nuestros clientes.</span>
              </p>
              <p>
                Nuestra experiencia y capacidad en la <span className="bold">toma de decisiones</span> da <span className="bold">solución inmediata</span> a las problemáticas de cada obra.
              </p>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Partners.js